import { type MutationHookOptions, useMutation } from '@apollo/client';
import { useCallback } from 'react';
import type {
  CreateExpenseType,
  CreateExpenseTypeInput,
  CreateExpenseTypeVariables,
  DeleteExpenseType,
  DeleteExpenseTypeVariables,
  UpdateExpenseType,
  UpdateExpenseTypeVariables,
} from 'types/graphql';
import ExpenseTypesApi from '../api/ExpenseTypes.api';

export function useCreateExpenseType(options?: MutationHookOptions<CreateExpenseType, CreateExpenseTypeVariables>) {
  const [mutate, { loading, error }] = useMutation(ExpenseTypesApi.Create, options);
  const create = useCallback((input: CreateExpenseTypeInput) => mutate({ variables: { input } }), [mutate]);
  return { create, loading, error };
}

export function useUpdateExpenseType(options?: MutationHookOptions<UpdateExpenseType, UpdateExpenseTypeVariables>) {
  const [mutate, { loading, error }] = useMutation(ExpenseTypesApi.Update, options);
  const update = useCallback(
    ({ id, input }: UpdateExpenseTypeVariables) => mutate({ variables: { id, input } }),
    [mutate]
  );
  return { update, loading, error };
}

export function useDeleteExpenseType(options?: MutationHookOptions<DeleteExpenseType, DeleteExpenseTypeVariables>) {
  const [mutate, { loading, error }] = useMutation(ExpenseTypesApi.Delete, options);
  const remove = useCallback((id: number) => mutate({ variables: { id } }), [mutate]);
  return { remove, loading, error };
}
